import {
    useState,
    useRef
} from 'react';
import { useHistory } from 'react-router-dom';
import {
    Container,
    Content,
    Options,
    Hello,
    Actions,
    ViewerCompanies,
    ResetPasswordStyled,
    User
} from './styled';
import {
    Avatar,
    Modal,
    ResetPassword,
    PreviewCompany
} from '../../components';
import { useOutsideAlerter } from '../../hooks';
import { useAuth } from '../../contexts/auth';
import { FaChevronDown } from "react-icons/fa6";
import { FiLogOut } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { FaRegLightbulb } from "react-icons/fa";
import {
    PiPasswordBold,
    PiBroomFill
} from "react-icons/pi";
import { BsBriefcase } from "react-icons/bs";

export function LoggedWrapper(props) {
    const history = useHistory();

    const {
        userLogged,
        companiesUser,
        isOpenAside
    } = props;
    const {
        signOut,
        company_id,
        signInByToken,
        functionality
    } = useAuth();

    const hasTutorialFunctionality = Array.isArray(functionality)
        ? functionality.includes('tutorial')
        : String(functionality).includes('tutorial');
    const refOptions = useRef(null);
    const [openOptions, setOpenOptions] = useState(false);
    const [openResetPassword, setOpenResetPassword] = useState(false);
    const [hideCompanies, setHideCompanies] = useState(true);

    useOutsideAlerter(refOptions, () => setOpenOptions(false));

    async function handleCompanyClick(company_id) {
        await signInByToken(company_id, userLogged?.id);
    };
    function handleSelectCompanies() {
        window.location.href = "/user-companies";
    };
    function handleOpenResetPassword() {
        setOpenOptions(false);
        setOpenResetPassword(true);
    };
    function handleClearCache() {
        document.location.reload(true);
    };
    function handleSignOut() {
        signOut();
    }
    function handleTutorials(userLogged) {
        history.push('/archived-tutorials', { userLogged });
    }

    const filteredCompanies = companiesUser?.filter((company) => {
        return company?.id !== company_id;
    });
    const mappedCompanies = filteredCompanies?.map((
        { id, ...otherCompanyProps }
    ) => (
        <PreviewCompany
            key={id}
            company={{ id, ...otherCompanyProps }}
            onClick={() => handleCompanyClick(id)}
        />
    ));
    
    return (
        <>
            <Container ref={refOptions}>
                <Content
                    onClick={
                        () => setOpenOptions(!openOptions)
                    }
                >
                    <User isOpenAside={isOpenAside}>
                        <Avatar
                            className={'avPef'}
                            name={userLogged?.nomecompleto}
                            width={'3rem'}
                            height={'3rem'}
                            borderRadius={'.657rem'}
                            fontSize={'1.2rem'}
                        />
                        <div>
                            <span className="name">{userLogged?.nomecompleto}</span>
                            <span className="username">{userLogged?.nomeusuario}</span>
                        </div>
                    </User>
                </Content>
                <Options isOpen={openOptions} isOpenAside={isOpenAside}>
                    <div>
                        {/* <Hello>
                            {`Olá, ${userLogged?.nomecompleto}`}
                        </Hello> */}
                        {/* <span
                            className='ioClose'
                            onClick={() => setOpenOptions(!openOptions)}
                        >
                            <IoClose />
                        </span> */}
                    </div>
                    <Actions className={(!hideCompanies) ? 'gp-2' : 'gp-1'}>
                        {(companiesUser?.length > 1) &&
                            <>
                                <div onClick={() => { setHideCompanies(!hideCompanies) }}>
                                    {`${(!hideCompanies)
                                        ? 'Ocultar'
                                        : 'Mostrar'} 
                                        Empresas`
                                    }
                                    <FaChevronDown
                                        className={
                                            `rotating ${!hideCompanies && 'rotated'}
                                        `}
                                    />
                                </div>

                                <ViewerCompanies
                                    className={`${(hideCompanies) && 'hideCompanies'}`}
                                >
                                    {mappedCompanies}
                                </ViewerCompanies>
                                <div onClick={() => handleSelectCompanies()}>
                                    <span>
                                        <BsBriefcase fontSize={`1.13rem`} />
                                        {`Selecionar Empresas`}
                                    </span>
                                </div>
                            </>
                        }
                        <div onClick={() => handleOpenResetPassword()}>
                            <span>
                                <PiPasswordBold fontSize={`1.13rem`} />
                                {`Redefinir Senha`}
                            </span>
                        </div>
                        <div onClick={() => handleClearCache()}>
                            <span>
                                <PiBroomFill fontSize={`1.13rem`} />
                                {`Limpar`}
                            </span>
                        </div>
                        {hasTutorialFunctionality && (
                            <div onClick={() => handleTutorials(userLogged)}>
                                <span>
                                    <FaRegLightbulb fontSize={`1.13rem`} />
                                    {`Tutoriais`}
                                </span>
                            </div>
                        )}
                        <div onClick={() => handleSignOut()}>
                            <span>
                                <FiLogOut fontSize={`1.13rem`} />
                                {`Sair`}
                            </span>
                        </div>
                    </Actions>
                </Options>
            </Container>
            <Modal
                isOpen={(openResetPassword) ? 1 : 0}
                title={`Redefinir Senha`}
                close={() => setOpenResetPassword(false)}
            >
                <ResetPasswordStyled>
                    {(openResetPassword) &&
                        <ResetPassword
                            onBack={() => setOpenResetPassword(false)}
                        />
                    }
                </ResetPasswordStyled>
            </Modal>
        </>
    )
}